import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const adjustmentService = createApi({
  reducerPath: "adjustmentService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getAdjustment: builder.query<any, any>({
      query: (params) => ({
        url: `/adjustment`,
        params,
        method: "GET",
        headers: {
          PageName: "Adjustment Management",
        },
      }),
    }),
    getAdjustmentDetail: builder.query<any, { id: string }>({
      query: ({id}) => ({
        url: `/adjustment/${id}`,
        method: "GET",
        headers: {
          PageName: "Adjustment Management",
        },
      }),
    }),
    createAdjustment: builder.mutation<any, any>({
      query: (body) => ({
        url: `/adjustment`,
        body: body,
        method: "POST",
        headers: {
          PageName: "Adjustment Management",
        },
      }),
    }),
    updateAdjustment: builder.mutation<any, any>({
      query: (body) => ({
        url: `/adjustment/${body.id}`,
        body: body,
        method: "PUT",
        headers: {
          PageName: "Adjustment Management",
        },
      }),
    }),
    getAdjustmentLogs: builder.query<any, { id: string }>({
      query: ({ id }) => ({
        url: `/adjustment/${id}/payout`,
        method: "GET",
        headers: {
          PageName: "Adjustment Management",
        },
      }),
    }),
  }),
});

export const {
  useLazyGetAdjustmentQuery,
  useLazyGetAdjustmentDetailQuery,
  useCreateAdjustmentMutation,
  useUpdateAdjustmentMutation,
  useLazyGetAdjustmentLogsQuery,
}
= adjustmentService;